import {connectService} from 'components/service/connectService'
import {Admin} from 'modules/admin/Admin'
import {NavigationContext} from 'modules/dashboard/NavigationContext'
import {useContext, useEffect, useMemo, useRef} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {Tooltip} from 'react-tooltip'
import {Roles, getInitials} from 'utility/utility'

export const Businesses = connectService(
  props => {
    const navigate = useNavigate()
    const params = useParams()
    const {setTitle} = useContext(NavigationContext)

    useEffect(() => {
      setTitle('Businesses')
    }, [])

    const {list, loading, Loader, Placeholder, Paginator, rehydrate} = props
    const adminModalRef = useRef(null)

    const distributor = useMemo(() => {
      return params?.distributor || false
    }, [params])

    const reseller = useMemo(() => {
      return params?.reseller || false
    }, [params])

    return (
      <>
        <div className="table-responsive-mask">
          <div className="table-responsive">
            <table className="vw-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Distributor</th>
                  <th>Reseller</th>
                  <th>Admins</th>
                  <th>Details</th>
                  <th>&nbsp; </th>
                </tr>
              </thead>
              <tbody>
                {list.length ? (
                  list.map(item => (
                    <tr key={item._id}>
                      <td>
                        <Link className="no-link-btn">
                          <div className="vw-table__name">
                            <div className="vw-table__name__no-img vw-icon-bg">{getInitials(item.name)}</div>{' '}
                            {item.name}
                          </div>
                        </Link>
                      </td>
                      <td>{item?.distributor?.name || '-'}</td>
                      <td>{item?.reseller?.name || '-'}</td>
                      <td>
                        <ul className="vw-table__admins">
                          <li className="vw-table__admins__add">
                            <button
                              className="btn-add addAdmin"
                              onClick={e => {
                                e.stopPropagation()
                                const payload = {
                                  adminOf: item._id,
                                  entity: 'business',
                                  business: item._id,
                                  permissions: [Roles.business]
                                }

                                if (distributor) {
                                  payload.distributor = distributor
                                }

                                if (reseller) {
                                  payload.reseller = reseller
                                }

                                adminModalRef.current.show(payload)
                              }}
                            >
                              <i className="fal fa-plus"></i>
                            </button>
                          </li>
                          {item?.admins.length ? (
                            item.admins.map(admin => (
                              <li key={admin._id}>
                                <div className="vw-table__admins__no-img vw-icon-bg vw-icon-bg--j">
                                  {getInitials(`${admin.firstName} ${admin.lastName}`)}
                                </div>
                              </li>
                            ))
                          ) : (
                            <li>-</li>
                          )}
                        </ul>
                      </td>

                      <td>
                        <ul className="vw-table__details">
                          <li data-tooltip-id={`statistics-${item._id}-groups`}>
                            {item?.statistics?.groups} <i className="fal fa-window-restore"></i>
                            <Tooltip
                              id={`statistics-${item._id}-groups`}
                              place="top"
                              content={`${item?.statistics?.groups} Groups`}
                            />
                          </li>
                          <li data-tooltip-id={`statistics-${item._id}-devices`}>
                            {item?.statistics?.devices} <i className="fal fa-window-maximize"></i>
                            <Tooltip
                              id={`statistics-${item._id}-devices`}
                              place="top"
                              content={`${item?.statistics?.devices} Devices`}
                            />
                          </li>
                        </ul>
                      </td>
                      <td>
                        <button
                          onClick={e => {
                            e.stopPropagation()
                            navigate(item._id)
                          }}
                          className="btn btn-primary"
                        >
                          Edit/Devices
                        </button>
                      </td>
                    </tr>
                  ))
                ) : loading ? (
                  <Loader colSpan={6} />
                ) : (
                  <Placeholder colSpan={6} placeholder="No Businesses" />
                )}
              </tbody>
            </table>
            <div className="vw-group-button">
              <button
                onClick={() => navigate('create')}
                className="btn btn-add btn-add--lg vw-tab-group-button"
              >
                <i className="fal fa-plus"></i>
              </button>
            </div>
          </div>
          <Admin ref={adminModalRef} onCreated={() => rehydrate()} />
        </div>
        {Paginator({className: 'd-flex flex-row-reverse mt-2'})}
      </>
    )
  },
  'business',
  {
    query: {
      $populate: ['distributor', 'reseller'],
      $sort: {name: 1}
    },
    paramsAsQueryParams: ['distributor', 'reseller']
  }
)
